export default "__VITE_ASSET__CGRif_$w__"